import {
  apiRequest,
  PemadananDetail,
} from "../../../../../services/adapters/kepegawaian/pemadananService";

class DetailRepository {
  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      PemadananDetail,
      {
        params: query,
      },
      true
    );
  };
}

export default DetailRepository;
